import { useState, useEffect } from 'react';
import { constructPhotoUrl } from '../utils/imageProcessing';

export const useMinisterPhoto = (filename: string | null | undefined) => {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!filename) {
      setPhotoUrl(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
      const url = constructPhotoUrl(supabaseUrl, filename);
      
      if (!url) {
        setPhotoUrl(null);
        setError(new Error('Could not construct photo URL'));
        setIsLoading(false);
        return;
      }

      // Verify image exists
      const img = new Image();
      img.onload = () => {
        setPhotoUrl(url);
        setIsLoading(false);
      };
      img.onerror = () => {
        setPhotoUrl(null);
        setError(new Error('Photo not found'));
        setIsLoading(false);
      };
      img.src = url;
    } catch (err) {
      // Photo doesn't exist or other error - this is expected for ministers without photos
      setPhotoUrl(null);
      setError(err instanceof Error ? err : new Error('Failed to load photo'));
      setIsLoading(false);
    }
  }, [filename]);

  return { photoUrl, isLoading, error };
};
